import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableSelectionBarStandaloneDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../../types";
import {
    getElevationLayers
} from "../../../../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    wrapper: {
        pointerEvents: "box-none",
        position: "absolute",
        alignItems: "center",
        start: 0,
        end: 0
    },
    bar: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        maxWidth: "100%"
    },
    count: {
        flexShrink: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    controlHeights,
    bottomOffset,
    shapeConfigs,
    shadowAlpha,
    elevations,
    radiuses,
    colors,
    spaces
}: DataTableSelectionBarStandaloneDynamicStyleType) => {
    const styles = {
        bar: {
            minHeight: controlHeights.small + spaces.spacingSm * 2,
            backgroundColor: colors.content.container.inverse,
            boxShadow: getElevationLayers({
                shadowColor: colors.system.shadow,
                level: "level3",
                shadowAlpha,
                elevations
            }),
            paddingHorizontal: spaces.spacingMd,
            paddingVertical: spaces.spacingSm,
            gap: spaces.spacingSm,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        wrapper: {
            paddingHorizontal: spaces.spacingMd,
            bottom: bottomOffset
        } as Mutable<ViewStyle>,
        count: {
            marginEnd: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
